import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { routeModuleMap } from "../../routeModuleMap"; // You’ll create this next

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const userDetails = useSelector((state) => state.auth.userDetails);
  const allowedModules = userDetails?.role_modules?.modules?.map((mod) => mod.module_id) || [];

  //console.log( "PM route >> ", userDetails );

  if( userDetails?.role_name !== 'Admin' ) {
    const requiredModuleId = routeModuleMap[location.pathname];

    if (requiredModuleId && !allowedModules.includes(requiredModuleId)) {
      return <Navigate to="/unauthorized" state={{ from: location }} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
